import { IBaseTheme } from "./ThemeTypes";

export const BaseTheme: IBaseTheme = {
  typography: {
    font: '"Roboto", "Segoe UI", BlinkMacSystemFont, system-ui, -apple-system',
    display: {
      large_prominent: {
        font_size: 57,
        line_height: 64,
        letter_spacing: -0.25,
        font_weight: 400,
      },
      large: {
        font_size: 57,
        line_height: 64,
        letter_spacing: -0.25,
        font_weight: 400,
      },
      medium_prominent: {
        font_size: 45,
        line_height: 52,
        letter_spacing: 0,
        font_weight: 400,
      },
      medium: {
        font_size: 45,
        line_height: 52,
        letter_spacing: 0,
        font_weight: 400,
      },
      small: {
        font_size: 36,
        line_height: 44,
        letter_spacing: 0,
        font_weight: 400,
      },
    },
    headline: {
      large_prominent: {
        font_size: 32,
        line_height: 40,
        letter_spacing: 0,
        font_weight: 400,
      },
      large: {
        font_size: 32,
        line_height: 40,
        letter_spacing: 0,
        font_weight: 400,
      },
      medium_prominent: {
        font_size: 28,
        line_height: 36,
        letter_spacing: 0,
        font_weight: 400,
      },
      medium: {
        font_size: 28,
        line_height: 36,
        letter_spacing: 0,
        font_weight: 400,
      },
      small: {
        font_size: 24,
        line_height: 32,
        letter_spacing: 0,
        font_weight: 400,
      },
    },
    title: {
      large_prominent: {
        font_size: 22,
        line_height: 28,
        letter_spacing: 0,
        font_weight: 400,
      },
      large: {
        font_size: 22,
        line_height: 28,
        letter_spacing: 0,
        font_weight: 400,
      },
      medium_prominent: {
        font_size: 16,
        line_height: 24,
        letter_spacing: 0.15,
        font_weight: 500,
      },
      medium: {
        font_size: 16,
        line_height: 24,
        letter_spacing: 0.15,
        font_weight: 500,
      },
      small: {
        font_size: 14,
        line_height: 20,
        letter_spacing: 0.1,
        font_weight: 500,
      },
    },
    label: {
      large_prominent: {
        font_size: 14,
        line_height: 20,
        letter_spacing: 0.1,
        font_weight: 600,
      },
      large: {
        font_size: 14,
        line_height: 20,
        letter_spacing: 0.1,
        font_weight: 500,
      },
      medium_prominent: {
        font_size: 12,
        line_height: 16,
        letter_spacing: 0.5,
        font_weight: 600,
      },
      medium: {
        font_size: 12,
        line_height: 16,
        letter_spacing: 0.5,
        font_weight: 500,
      },
      small: {
        font_size: 11,
        line_height: 16,
        letter_spacing: 0.5,
        font_weight: 500,
      },
    },
    body: {
      large_prominent: {
        font_size: 16,
        line_height: 24,
        letter_spacing: 0.5,
        font_weight: 400,
      },
      large: {
        font_size: 16,
        line_height: 24,
        letter_spacing: 0.5,
        font_weight: 400,
      },
      medium_prominent: {
        font_size: 14,
        line_height: 20,
        letter_spacing: 0.25,
        font_weight: 400,
      },
      medium: {
        font_size: 14,
        line_height: 20,
        letter_spacing: 0.25,
        font_weight: 400,
      },
      small: {
        font_size: 12,
        line_height: 16,
        letter_spacing: 0.4,
        font_weight: 400,
      },
    },
    special_characters: {
      space: "\u00A0",
    },
  },
  button: {
    radius: "9999px",
    padding: "16px",
    height: "40px",
  },
  elevation: {
    level1_shadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
    level2_shadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
    level3_shadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
  },
  custom_colors: {
    blue: "8, 66, 126",
    red: "213, 12, 19",
    yellow: "230, 202, 12",
    green: "46, 125, 50",
  },
  print: {
    page: "255, 255, 255",
    ink: "26, 26, 26",
    ink_muted: "97, 97, 97",
    rule: "48, 48, 48",
    border: "189, 189, 189",
    band_pub: "213, 230, 247",
    band_zone: "251, 243, 199",
    band_stage: "248, 215, 215",
    band_section: "212, 237, 218",
  },
  left_nav: {
    drawer_width_px: 320,
    rail_width_px: 80,
    padding_top: "8px",
    padding_bottom: "8px",
    padding_left: "12px",
    padding_right: "12px",
    radius: "16px",
    transition_length: "0.2s",
  },
  content: {
    radius: "16px",
    padding: "16px",
    margin_right: "16px",
    margin_bottom: "16px",
  },
  responsive: {
    mobile: 840,
  },
  tooltip: {
    padding_vertical: "4px",
    padding_horizontal: "8px",
    border_radius: "4px",
    font_size: "12px",
    font_weight: 500,
    line_height: "16px",
    letter_spacing: "0.5px",
  },
  opacity: {
    disabled_container: 0.1,
    disabled_content: 0.38,
    hover_state_layer: 0.08,
    pressed_state_layer: 0.1,
  },
  motion: {
    duration: {
      short3: 150,
      short4: 200,
      medium2: 300,
      long2: 500,
    },
    easing: {
      standard: "cubic-bezier(0.2, 0, 0, 1)",
      standard_decelerate: "cubic-bezier(0, 0, 0, 1)",
      standard_accelerate: "cubic-bezier(0.3, 0, 1, 1)",
      ease_in_out: "ease-in-out",
    },
  },
  z_index: {
    base: 0,
    sticky: 1,
    scrim: 998,
    navigation: 999,
    snackbar: 1000,
    overlay: 9999,
  },
};
